import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Link from 'common/components/LocalizedLink/LocalizedLink';

import styles from './TagsVerticalList.module.scss';

export default class TagsVerticalListComponent extends Component {
  static propTypes = {
    className: PropTypes.string,
    tags: PropTypes.array
  };

  static defaultProps = {
    className: '',
    tags: []
  };

  constructor(props) {
    super(props);

    this.state = {
      tags: props.tags
    };
  }

  render() {
    const { className } = this.props;
    const { tags } = this.state;

    const tagsList = tags.map((item, i) => (
      <div key={i} className={styles.TagWrapper}>
        <Link to={item.anchor}>
          <p className={styles.Tag}>{item.name}</p>
        </Link>
      </div>
    ));

    return <div className={`${styles.Tags} ${className}`}>{tagsList}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/TagsVerticalList/TagsVerticalList.js